import { errorAction } from '../modules/notifications';
import { API } from '../../config';
import Auth from '../../services/auth';

class Base {
  constructor(entity, initialState) {
    this.entity = entity;
    this.baseUrl = API;
    this.initialState = initialState;
    this.GET = `${entity}/GET`;
    this.PUT = `${entity}/PUT`;
    this.CREATE = `${entity}/CREATE`;
    this.FETCH = `${entity}/FETCH`;
    this.DELETE = `${entity}/DELETE`;
    this.RESET = `${entity}/RESET`;
    this.defaultHeaders = {
      'Content-Type': 'application/json',
      'X-Skip-Subdomain-Redirect': 'true'
    };
  }

  headers() {
    const AuthService = Auth;
    const api_token = (AuthService.getUserInfo() || {}).api_token;
    const headers = { ...this.defaultHeaders };

    if (api_token) {
      headers.Authorization = `Bearer ${api_token}`;
    }
    return headers;
  }

  reducer(state = this.initialState, action = {}) {
    const withInitialState = {
      ...state,
      initialState: this.initialState
    };
    switch (action.type) {
      case this.GET: {
        const defaultValues = state.isSingleObject ? {} : [];
        return {
          ...withInitialState,
          values: action.data || defaultValues,
          isFetching: false
        };
      }
      case this.PUT: {
        const values = state.isSingleObject ? action.data : state.values.concat(action.data || []);

        return {
          ...withInitialState,
          values
        };
      }
      case this.CREATE: {
        return {
          ...withInitialState,
          values: state.isSingleObject ? action.data : state.values.concat(action.data || [])
        };
      }
      case this.FETCH: {
        return {
          ...withInitialState,
          isFetching: true,
          values: state.isSingleObject ? {} : []
        };
      }
      case this.RESET: {
        return {
          ...withInitialState,
          isFetching: false,
          values: state.isSingleObject ? {} : []
        };
      }
      case this.DELETE: {
        return {
          ...withInitialState,
          values: state.isSingleObject ? {} : []
        };
      }
      default: {
        return withInitialState;
      }
    }
  }

  get(data) {
    return {
      type: this.GET,
      data
    };
  }

  fetch() {
    return {
      type: this.FETCH
    };
  }

  reset() {
    return {
      type: this.RESET
    };
  }

  put(data) {
    return {
      type: this.PUT,
      data
    };
  }

  create(data) {
    return {
      type: this.CREATE,
      data
    };
  }

  delete() {
    return {
      type: this.DELETE
    };
  }

  getAsync(url) {
    return (dispatch) => {
      dispatch(this.fetch());
      const options = {
        method: 'GET',
        headers: this.headers()
      };

      return fetch(`${this.baseUrl}/${url}`, options)
        .then((response) => {
          if (response.status > 400) {
            return false;
          }
          return response.json();
        })
        .then((response) => {
          dispatch(this.get(response));
          return response;
        })
        .catch((e) => {
          console.log(e);
          dispatch(errorAction());
          throw e;
        });
    };
  }

  postAsync(url, data) {
    return (dispatch) => {
      const options = {
        method: 'POST',
        body: JSON.stringify(data),
        headers: this.headers()
      };

      return fetch(`${this.baseUrl}/${url}`, options)
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          dispatch(this.create(data));
          return response;
        })
        .catch((e) => {
          console.log(e);
          dispatch(errorAction());
          throw e;
        });
    };
  }

  putAsync(url, data) {
    return (dispatch) => {
      const options = {
        method: 'PUT',
        body: JSON.stringify(data)
      };

      options.headers = this.headers();

      return fetch(`${this.baseUrl}/${url}`, options)
        .then((response) => {
          return response.json();
        })
        .then((receivedData) => {
          dispatch(this.put(receivedData));
          return receivedData;
        })
        .catch((e) => {
          console.log(e)
          dispatch(errorAction());
        });
    };
  }

  deleteAsync(url) {
    return (dispatch) => {
      const options = {
        method: 'DELETE'
      };

      options.headers = this.headers();

      return fetch(`${this.baseUrl}/${url}`, options)
        .then((response) => {
          dispatch(this.delete());
          return response;
        })
        .catch((e) => {
          console.log(e);
          dispatch(errorAction());
          throw e;
        });
    };
  }
}

export default Base;



// WEBPACK FOOTER //
// ./src/redux/modules/Base.js